import { DRUPAL_NODE_DISPLAY, type DrupalNode } from '@commons/types/drupal';

import FAQNodeCollapsible from './Collapsible';
import FAQNodeDefault from './Default';

/**
 * Type definition of a FAQ node properties.
 */

export type FAQNodeProps = DrupalNode & {
  question: string;
  answer: string;
  anchor?: string;
};

/**
 * FAQ node component.
 *
 * Renders a component based on the display type.
 */

export const FAQNode = (props: FAQNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
      return <FAQNodeDefault {...props} />;
    case DRUPAL_NODE_DISPLAY.Collapsible:
      return <FAQNodeCollapsible {...props} />;
  }
};

export default FAQNode;
